import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-loader-y";
import { formValueSelector } from "redux-form";
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { InView } from 'react-intersection-observer';
import Loader from '../../Common/Loader/Loader';
import SearchResultsSkeleton from '../../Skeleton/Categories/SearchResultsSkeleton/SearchResultsSkeleton';
import { getCategoryResults } from '../../../actions/category/getCategoryResults';
import searchCategoryQuery from './searchCategory.graphql';
import messages from '../../../locale/messages';
import noResult from "../../../../public/Icons/noResults.svg"
import { searchLimit } from '../../../config';
import CategoryItem from "../CategoryItem/CategoryItem"
import { encode } from '../../../helpers/queryEncryption';
import { withQuery } from '../../../hoc/withGraphql';
import { openHeaderModal } from '../../../actions/siteadmin/modalActions';
import { setRuntimeVariable } from '../../../actions/runtime';
import history from '../../../history';
import bt from "../../commonStyle.css"
import s from './SearchResult.css';

class SearchResults extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isScrollMoreLoader: false
        };
    }

    handleInViewChange = (inView) => {
        if (inView) this.scrollMore();
    };

    scrollMore = async () => {
        const {
            getCategoryResultData: { searchCategory, fetchMore },
            categoryValue,
        } = this.props;
        const offset = searchCategory?.results?.length || 0;
        this.setState({ isScrollMoreLoader: true });
        await fetchMore({
            query: searchCategoryQuery,
            fetchPolicy: 'network-only',
            variables: {
                offset,
                loadCount: searchLimit,
                searchList: categoryValue,
            },

            updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                    this.setState({ isScrollMoreLoader: false });
                    return {
                        searchCategory: {
                            results: [...searchCategory?.results]
                        },
                    };
                }

                const previousResults = searchCategory?.results || [];
                const updatedResults = fetchMoreResult?.searchCategory?.results || [];

                this.setState({ isScrollMoreLoader: false });

                return {
                    searchCategory: {
                        ...previousResult?.searchCategory,
                        results: [...previousResults, ...updatedResults],
                    },
                };
            },
        });
    };

    handleClickCategory = (redirectUrl) => {
        const { isAuthenticated, openHeaderModal, setRuntimeVariable } = this.props;
        if (isAuthenticated) return history.push(redirectUrl);
        setRuntimeVariable({ name: 'referUrl', value: redirectUrl });
        openHeaderModal('loginModal');
    }

    render() {
        const { getCategoryResultData: { searchCategory, loading }, allCategoryloading } = this.props;
        const isDataReady = !loading && searchCategory;
        const { isScrollMoreLoader } = this.state;
        if (allCategoryloading || !isDataReady) {
            return <SearchResultsSkeleton />
        }

        return (
            <div>
                {searchCategory?.results?.length > 0 ? (
                    <InfiniteScroll
                        loader={isScrollMoreLoader ? <Loader type={"text"} /> : <></>}
                        dataLength={searchCategory?.results?.length}
                        loadMore={() => this.scrollMore()}
                        hasMore={(searchCategory?.results?.length) < searchCategory?.count}
                        startPage={Math.ceil(searchCategory?.results?.length / searchLimit)}
                    >
                        <div className={s.allCategoryList}>
                            {searchCategory?.results?.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() =>
                                        this.handleClickCategory(`/category?type=${encodeURIComponent(encode(item?.id?.toString()))}`)
                                    }
                                    className={s.allCategoryListItem}
                                >
                                    <CategoryItem
                                        categoryId={item?.id}
                                        categoryName={item?.name}
                                        categoryLogo={item?.logoImage}
                                    />
                                </div>
                            ))}
                        </div>
                    </InfiniteScroll>
                ) : (
                    <div className={cx(s.subCategoryNoListItem, bt.textAlignCenter)}>
                        <div className={s.subCategoryNoListImgContainer}>
                            <img src={noResult} alt="" role="presentation" />
                        </div>
                        <FormattedMessage {...messages.noResult} />
                    </div>
                )}
                <InView onChange={this.handleInViewChange}>
                </InView>
            </div>
        )
    }
}

const selector = formValueSelector("SearchForm");

const mapState = (state) => ({
    categoryName: selector(state, "categoryName"),
    isAuthenticated: state?.runtime?.isAuthenticated,
});

const mapDispatch = {
    getCategoryResults,
    openHeaderModal,
    setRuntimeVariable
};

export default compose(
    injectIntl,
    withStyles(bt, s),
    connect(mapState, mapDispatch),
    withQuery(searchCategoryQuery, {
        name: "getCategoryResultData",
        options: (props) => ({
            variables: {
                searchList: props.categoryValue
            },
            ssr: false,
            fetchPolicy: "network-only",
        }),
    })
)(SearchResults);